import { render, staticRenderFns } from "./ActiveQuizzes.vue?vue&type=template&id=97ed3c0c&scoped=true"
import script from "./ActiveQuizzes.vue?vue&type=script&lang=js"
export * from "./ActiveQuizzes.vue?vue&type=script&lang=js"
import style0 from "./ActiveQuizzes.vue?vue&type=style&index=0&id=97ed3c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ed3c0c",
  null
  
)

export default component.exports